// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__1lIL9","label":"Select_label__1TKb0"};